const BffGenericErrorCode = {
  UNKNOWN: 'UNKNOWN',
};

module.exports = BffGenericErrorCode;
